import * as React from "react";
import './link-invalido.css';

export default class LinkInvalidoComponent extends React.Component {
  render() {
    const currentDate = new Date();
    const formattedDate = `${currentDate.toLocaleDateString()} às ${currentDate.toLocaleTimeString()}`;

    return (
      <div className="link-invalido">
        <div className="link-invalido-content">
          <div className="logo">
            <img className="img-logo" src="src/assets/images/logo-bmg.png" />
          </div>
          <div className="erro">
            <img className="img-erro" src="src/assets/images/erro.png" />
          </div>
          <div className="link-invalido-description">
            <h1 className="link-invalido-text-description">Link expirado</h1>
          </div>
          <div className="link-invalido-date-description">
            <label className="link-invalido-text-date-description">
              {formattedDate}
            </label>
          </div>
          <div className="link-invalido-description-error">
            <label className="link-invalido-text-description-error">
              Este link não é mais válido para validação de identidade. Entre em contato com a Central de Atendimento para que seja gerado um novo link de validação.
            </label>
          </div>
        </div>
        <div className="content-wrapper">
          <div className="description">
            <p className="text-description">
              Precisa de mais informações? Entre em contato com a Central de Atendimento do Banco Bmg:
            </p>
          </div>
          <div className="contatos">
            <div className="contato">
              <div className="text-contato">
                0800 770 1790
              </div>
              <div className="img-contato">
                <img src="src/assets/images/contato.png" />
              </div>

            </div>
            <div className="text-caption">
              Ligações de telefone fixo
            </div>
            <div className="contato">
              <div className="text-contato">
                4002 7007
              </div>
              <div className="img-contato">
                <img src="src/assets/images/contato.png" />
              </div>
            </div>
            <div className="text-caption">
              Ligações de celular
            </div>
          </div>
          <a href="https://bancobmg.com.br" target="_blank" >
            <button className="button-primario">Acessar bancobmg.com.br</button>

          </a>

        </div>
      </div>
    );
  }
}
